import propTypes from 'prop-types';
import { PureComponent as Component } from 'react';
import { Button as ButtonBootstrap } from 'reactstrap';
import withVerifiedUser from '../hoc/withVerifiedUser';

class ProtectedButton extends Component{
  render(){
    return (
      this.props.children?
      this.props.children :
      this.props.childrenFunc? this.props.childrenFunc(this.props):
      <ButtonBootstrap
        disabled={this.props.disabled}
        size={this.props.size}
        block={this.props.block}
        style={this.props.style}
        className={this.props.className}
        onClick={this.props.onClick}
        children={this.props.children}
      >
        {this.props.disabled?this.props.loadingText:this.props.buttonText}
      </ButtonBootstrap>
    )
  }
}
export default withVerifiedUser(ProtectedButton);

ProtectedButton.propTypes={
  disabled:propTypes.bool,
  loadingText:propTypes.string,
  className:propTypes.string,
  block:propTypes.bool,
  size:propTypes.string,
  buttonText:propTypes.string.isRequired,
  children: propTypes.node,
  category: propTypes.string
}
ProtectedButton.defaultProps={
  tag: 'div',
  loadingText:'Submitting...',
  className:'',
  size:'md',
  category: 'sneakers'
}
